<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <Row :gutter="20" v-if="isAdd">
                <Col span="24">
                    <FormItem prop="billStatus" label="账单">
                        <check-tag-group
                            style="display: inline-block"
                            v-model="info.billStatus"
                            color="primary"
                        >
                            <check-tag
                                v-for="item in billStatusList"
                                :name="item.id"
                                :key="item.id"
                            >
                                {{ item.text }}
                            </check-tag>
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="houseId" label="房源名称">
                        <form-lookup
                            style="min-width: 262px; margin-right: 15px"
                            v-model="lookupOptions.roomId"
                            :options.sync="lookupOptions.roomId"
                            :placeholder="isView ? '' : '请选择房号'"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                            :disabled="!isAdd && !isView"
                            @clear="clear"
                            @deselect="clear"
                        >
                            <select-room houseStatus="3" :allowCheckParent="false" />
                        </form-lookup>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="账期" prop="period">
                        <Select
                            v-model="info.period"
                            transfer
                            :placeholder="isView || !isAdd ? '' : '请选择账期'"
                            :disabled="!isAdd && !isView"
                            @on-change="changePeriod"
                        >
                            <Option
                                v-for="item in periodList"
                                :value="item.period"
                                :key="item.period"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusUser" label="客户姓名">
                        <Input
                            v-model="info.cusUser"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="cusMobile" label="客户手机号">
                        <Input
                            v-model="info.cusMobile"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <!-- 待收 -->
            <bill-form-receive
                v-if="status === '1' || status === '10'"
                :dict="dict"
                :info="info"
                :isAdd="isAdd"
                :isView="isView"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
            />

            <!-- 已收 -->
            <bill-form-received
                v-if="status === '2'"
                :dict="dict"
                :info="info"
                :isAdd="isAdd"
                :isView="isView"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
            />

            <!-- 待付 -->
            <bill-form-pay
                v-if="status === '3'"
                :dict="dict"
                :info="info"
                :isAdd="isAdd"
                :isView="isView"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
            />

            <!-- 已付 -->
            <bill-form-paid
                v-if="status === '4'"
                :dict="dict"
                :info="info"
                :isAdd="isAdd"
                :isView="isView"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
            />

            <!-- 作废 -->
            <bill-form-void v-if="status === '5'" :dict="dict" :info="info" />

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="上传图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="10"
                        />
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="4"
                            placeholder
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from '_u/dict'
import config from '@/config'
import { deepCopy, ymd, ymdL } from '_u/helper'
import { multiply } from '@/views/common/u-contract'

import SelectRoom from '_vc/select-room'
import PreviewUpload from '_c/preview-upload'
import BillFormReceive from './bill-form-receive'
import BillFormReceived from './bill-form-received'
import BillFormPay from './bill-form-pay'
import BillFormPaid from './bill-form-paid'
import BillFormVoid from './bill-form-void'

import { billView, billAdd, billUpdate, queryPeriods } from '@/api/bill'
import { assetsHouseView } from '@/api/assets'

export default {
    name: 'BillForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        depositOffset: {
            type: [String, Number],
            default: '',
        },
        offsetAmount: {
            type: [String, Number],
            default: '',
        },
        billStatus: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },

    components: {
        SelectRoom,
        PreviewUpload,
        BillFormReceive,
        BillFormReceived,
        BillFormPay,
        BillFormPaid,
        BillFormVoid,
    },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: '', // 数据编号
                billStatus: [this.billStatus], // 账单状态
                houseId: '', // 房间编号
                period: '', // 账单期数
                comName: '', // 公司名称
                contractId: '', // 合同Id
                startDate: '', // 开始日期
                endDate: '', // 结束日期
                cusUser: '', // 租客名称
                cusMobile: '', // 租客电话
                cusId: '', // 租客id
                planDate: '', // 应付款日
                feeType: '', // 费用类型
                planAmount: '', // 待收/待付金额
                realDate: '', // 实际收款/付款日期
                realAmount: '', // 实际收款/付款金额
                serviceFee: '', // 手续费
                leftPayDate: '', // 剩余金额应付款日
                payType: '', // 支付方式
                handleType: '', // 处理方式
                serviceFee: '',
                includeService: '',
                leftAmount: '', // 剩余金额
                attachments: '', // 附件
                submitTime: '', // 租客提交时间
                remark: '',
                ver: '',
            },
            periodList: [], // 账期列表
            lookupOptions: {
                roomId: [],
            },
            // filter: {},
            imgSuffix: config.upload.imgSuffix,
            dict: {
                billStatus: Dict.NULL,
                feeType: Dict.NULL,
                otherFee: Dict.NULL,
                payType: Dict.NULL,
                handleType: Dict.NULL,
            },
            billStatusList: [], // 账单状态
            isView: this.actionType === '2' ? true : false, // 查看
            isAdd: this.id === '' ? true : false, // 新增
            followKeys: ['contractId'],
            planAmount: '',
            realAmount: '',
        }
    },

    watch: {
        'lookupOptions.roomId': function (el) {
            let house = el[0] || { houseId: '', contractId: '' }
            Object.assign(this.info, {
                houseId: house.houseId,
                contractId: house.contractId,
            })
        },
    },

    computed: {
        ruleValidate() {
            let rule = {}
            if (this.isView) {
                return rule
            }
            if (this.isAdd) {
                rule = {
                    houseId: [{ required: true, message: '房源名称必填' }],
                    feeType: [{ required: true, message: '其他费用必填' }],
                }
            }
            // 待收 待付
            if (
                this.status === '1' ||
                this.status === '10' ||
                this.status === '3'
            ) {
                Object.assign(rule, {
                    planDate: [
                        {
                            required: true,
                            message: `应${
                                this.status === '1' || this.status === '10'
                                    ? '收'
                                    : '付'
                            }款日必填`,
                        },
                    ],
                    planAmount: [
                        {
                            required: true,
                            message: `应${
                                this.status === '1' || this.status === '10'
                                    ? '收'
                                    : '付'
                            }金额必填`,
                        },
                    ],
                })
            }
            // 已收 已付
            else if (this.status === '2' || this.status === '4') {
                Object.assign(rule, {
                    realDate: [
                        {
                            required: true,
                            message: `已${
                                this.status === '2' ? '收' : '付'
                            }款日必填`,
                        },
                    ],
                    realAmount: [
                        {
                            required: true,
                            message: `已${
                                this.status === '2' ? '收' : '付'
                            }金额必填`,
                        },
                    ],
                    payType: [
                        {
                            required: true,
                            message: '交易方式必填',
                        },
                    ],
                })
            }

            return rule
        },
        status() {
            return this.info.billStatus[0]
        },
    },
    methods: {
        clear() {
            this.lookupOptions.roomId = []
        },
        fetch() {
            if (this.id) {
                return billView(this.id)
            } else {
                this.$watch('info.contractId', function (val) {
                    if (val) {
                        queryPeriods(val).then((res) => {
                            const { cus, periods, contractId } = res.data
                            this.info.cusUser = cus.cusName
                            this.info.cusMobile = cus.cusMobile
                            this.info.cusId = cus.cusId
                            this.info.contractId = contractId
                            this.info.comName = cus.comName
                            const list = []
                            periods.forEach((v) => {
                                list.push({
                                    period: v.period,
                                    text: `第${v.period}期(${v.startDate} 至 ${v.endDate})`,
                                    startDate: v.startDate,
                                    endDate: v.endDate,
                                })
                            })
                            this.periodList = list
                        })
                    } else {
                        this.info.cusUser = ''
                        this.info.cusMobile = ''
                        this.info.period = ''
                        this.info.startDate = ''
                        this.info.endDate = ''
                        this.periodList = []
                    }
                })
                return Promise.resolve()
            }
        },
        // 账期更改
        changePeriod(index) {
            index -= 1
            this.info.startDate = this.periodList[index].startDate
            this.info.endDate = this.periodList[index].endDate
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                Dict.get([
                    'bill_status',
                    'fee_type',
                    'pay_type',
                    'other_fee',
                    'handle_type',
                ]),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.billStatusList = this.dict.billStatus
                        .toList()
                        .filter((v) => v.id < 5)
                    this.billStatusList.forEach((val) => {
                        if (val.id === '1') {
                            val.text = '待收'
                        }
                        if (val.id === '3') {
                            val.text = '待付'
                        }
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        this.info.billStatus = this.info.billStatus.split(',')
                        this.info.planAmount /= 100
                        this.info.realAmount /= 100
                        this.info.serviceFee = this.info.serviceFee / 100 || 0
                        this.planAmount = multiply(this.info.planAmount)
                        this.realAmount = multiply(this.info.realAmount)
                        this.info.leftAmount = this.info.leftAmount / 100 || 0
                        this.info.serviceFee = this.info.serviceFee / 100 || 0
                        this.info.includeService =
                            this.info.includeService / 100 || 0
                        this.info.invalidTime = ymdL(this.info.invalidTime)
                        this.info.comName = this.info.comName
                            ? this.info.comName
                            : ''
                        if (this.id && this.info.period) {
                            const info = this.info
                            this.periodList.push({
                                period: info.period,
                                text: `第${info.period}期(${info.startDate} 至 ${info.endDate})`,
                                startDate: info.startDate,
                                endDate: info.endDate,
                            })
                        }
                        return assetsHouseView(this.info.houseId)
                    }
                    return Promise.resolve()
                })
                .then((res) => {
                    if (res) {
                        const house = res.data.entity
                        this.lookupOptions.roomId.push({
                            id: this.info.houseId,
                            title: `${house.parkName}${house.floorName}${house.houseNum}`,
                        })
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = deepCopy(this.info)
                    delete formData.submitTime
                    formData.realAmount = multiply(formData.realAmount)
                    formData.planAmount = multiply(formData.planAmount)
                    formData.leftAmount = multiply(formData.leftAmount)
                    formData.serviceFee = multiply(formData.serviceFee)
                    formData.planDate = ymd(formData.planDate)
                    formData.realDate = ymdL(formData.realDate)
                    formData.startDate = ymd(formData.startDate)
                    formData.endDate = ymd(formData.endDate)
                    formData.billStatus = formData.billStatus[0]
                    delete formData.invalidTime
                    if (this.id) {
                        var updateAmount = true
                        if (
                            formData.billStatus === '1' ||
                            formData.billStatus === '3'
                        ) {
                            updateAmount =
                                this.planAmount == formData.planAmount
                        }

                        if (
                            formData.billStatus === '2' ||
                            formData.billStatus === '4'
                        ) {
                            updateAmount =
                                this.realAmount == formData.realAmount
                        }
                        formData.updateAmount = updateAmount ? 0 : 1
                        return billUpdate(formData)
                    } else {
                        return billAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
